import GailGptConversations from "./conversations";
import type {ConversationDetailsResponse} from "@/services/wingman/types";

/**
 * Legacy Wingman summaries omit the GPT owner. Resolve it from Galactus without
 * switching the conversation's deployment or treating read access as ownership.
 */
export async function resolveConversationOwner(conversation: ConversationDetailsResponse): Promise<ConversationDetailsResponse> {
   if (conversation.type !== "gpt" || conversation.userId) return conversation;
   const details = await GailGptConversations.getConversationDetails(conversation.id);
   if (details?.id !== conversation.id || details.type !== "gpt" || !details.userId) return conversation;
   return {...conversation, userId: details.userId};
}
